/* Lusty Owl · Holiday: code copy, countdown, snow (winter) or petals (spring). */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionOff = window.loxSettings && window.loxSettings.motion === false;

  /* copy discount code */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lox-code]');
    if (!b) return;
    var code = b.getAttribute('data-lox-code'), label = b.textContent;
    function done() {
      b.classList.add('is-copied'); b.textContent = 'Copied!';
      setTimeout(function () { b.classList.remove('is-copied'); b.textContent = label; }, 1600);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      try { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove(); } catch (err) {}
      done();
    }
  });

  /* countdown */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    document.querySelectorAll('[data-lox-cd]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-lox-cd'));
      if (isNaN(end)) { el.hidden = true; return; }
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s === 0) { var bar = el.closest('.lox-hbar'); if (bar) bar.hidden = true; return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      el.innerHTML = 'Ends in <b>' + d + 'd</b><b>' + pad(h) + 'h</b><b>' + pad(m) + 'm</b><b>' + pad(sec) + 's</b>';
    });
  }
  tick(); setInterval(tick, 1000);

  /* snow / petals */
  if (reduce || motionOff || root.getAttribute('data-lox-snow') !== 'on') return;
  var spring = root.classList.contains('lox-hol--spring');
  var c = document.createElement('canvas');
  c.className = 'lox-snow'; c.setAttribute('aria-hidden', 'true');
  var ctx = c.getContext('2d'), W, H, dpr, flakes = [], running = true, raf;
  var winterCols = ['rgba(15,61,46,.22)', 'rgba(200,16,46,.2)', 'rgba(217,164,65,.55)', 'rgba(140,160,185,.45)'];
  var springCols = ['rgba(247,182,207,.9)', 'rgba(255,214,228,.95)', 'rgba(233,185,73,.7)'];
  var cols = spring ? springCols : winterCols;

  function size() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth; H = window.innerHeight;
    c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var want = Math.round(Math.min(46, W / 30));
    while (flakes.length < want) flakes.push(make(true));
    flakes.length = want;
  }
  function make(anywhere) {
    return {
      x: Math.random() * W, y: anywhere ? Math.random() * H : -12,
      r: 3 + Math.random() * 4,
      vy: 0.35 + Math.random() * 0.9, vx: -0.3 + Math.random() * 0.6,
      a: Math.random() * Math.PI * 2, va: 0.01 + Math.random() * 0.02,
      col: cols[Math.floor(Math.random() * cols.length)]
    };
  }
  function draw() {
    if (!running) return;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i];
      f.a += f.va; f.y += f.vy; f.x += f.vx + Math.sin(f.a) * 0.4;
      if (f.y > H + 12 || f.x < -20 || f.x > W + 20) { flakes[i] = make(false); continue; }
      if (spring) {
        ctx.fillStyle = f.col; ctx.beginPath();
        ctx.ellipse(f.x, f.y, f.r, f.r * 0.55, f.a, 0, Math.PI * 2); ctx.fill();
      } else {
        ctx.strokeStyle = f.col; ctx.lineWidth = 1.4; ctx.lineCap = 'round'; ctx.beginPath();
        for (var k = 0; k < 3; k++) {
          var ang = f.a * 0.3 + k * Math.PI / 3, cx = Math.cos(ang) * f.r, cy = Math.sin(ang) * f.r;
          ctx.moveTo(f.x - cx, f.y - cy); ctx.lineTo(f.x + cx, f.y + cy);
        }
        ctx.stroke();
      }
    }
    raf = requestAnimationFrame(draw);
  }
  function start() {
    document.body.appendChild(c); size(); draw();
    window.addEventListener('resize', size);
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) { cancelAnimationFrame(raf); draw(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
